import { AboutActionTypes } from 'modules/about/actionTypes';

const getAboutNews = () => (dispatch, getState, { api }) => {
  dispatch({
    type: AboutActionTypes.NEWS.FETCH,
    payload: {},
    test: api
      .post(`newsPublication.json`)
      .then(res => {
        dispatch({
          type: AboutActionTypes.NEWS.SUCCESS,
          payload: res.data.data,
        });
        return res.data.data;
      })
      .catch(error => {
        dispatch({
          type: AboutActionTypes.NEWS.FAILURE,
          error,
        });
      }),
  });
};

export const AboutActions = {
  getAboutNews,
};
